// React Query hooks over the `field/classification-sets/` CRUD API
// (src/services/classificationSets.ts). Keeps the sets page and the builder's
// Classification field picker in sync.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteClassificationSet, listClassificationSets, saveClassificationSet } from "../services/classificationSets";
import { ClassificationSet, ClassificationSetInput, ClassificationSetType } from "../types/classificationSet";

const KEY = ["classification-sets"];

export function useClassificationSets(type?: ClassificationSetType) {
  return useQuery<ClassificationSet[]>({
    queryKey: type ? [...KEY, type] : KEY,
    queryFn: async () => listClassificationSets(type),
    staleTime: 0
  });
}

export function useSaveClassificationSet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: ClassificationSetInput) => saveClassificationSet(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteClassificationSet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => deleteClassificationSet(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
